import React, { useRef } from "react";
import { Image } from "primereact/image";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useNavigate } from "react-router-dom";
import { useLogo } from "../contexts/logoContext";

const MainMenu = () => {
  const menuRight = useRef(null);
  const navigate = useNavigate();
  const logo = useLogo(); // Usa el contexto del logo

  const items = [
    {
      label: "Calculadora",
      icon: "pi pi-calculator",
      command: () => {
        navigate("/calculator");
      },
    },
    {
      separator: true,
    },

    {
      label: "Créditos",
      icon: "pi pi-dollar",
      command: () => {
        navigate("/credits");
      },
    },
    {
      label: "Solicitudes",
      icon: "pi pi-exclamation-triangle",
      command: () => {
        navigate("/applications");
      },
    },
    {
      separator: true,
    },
    {
      label: "Mis datos",
      icon: "pi pi-user",
      command: () => {
        navigate("/beneficiariesForm");
      },
    },
    {
      separator: true,
    },
    {
      label: "Cerrar sesión",
      icon: "pi pi-power-off",
      command: () => {
        navigate("/logout", {
          replace: true,
        });
      },
    },
  ];

  return (
    <div className="flex w-full align-items-center flex-wrap menu-topbar" style={{ minHeight: '4.5rem' }}>
      <div className="flex w-5rem md:w-8rem justify-content-center align-items-center menu-logo">
        <Image src="/prestamosLogo.svg" alt="textum" width="90px" />
      </div>
      <div className="flex w-5rem md:w-8rem justify-content-center align-items-center menu-logo">
        <Image src={logo} alt="logo" width="90px" />
      </div>
      <div className="flex flex-grow-1"></div>

      <div className="flex align-items-center pb-3 pr-4">
        <Menu
          model={items}
          popup
          ref={menuRight}
          id="popup_menu_right"
          popupAlignment="center"
          className="w-14rem mt-2"
        />
        <Button
          aria-label="Bookmark"
          label={localStorage.getItem("personName")}
          icon="pi pi-cog"
          iconPos="right"
          onClick={(event) => menuRight.current.toggle(event)}
          className="bg-white text-color-secondary border-300 w-14rem menu-account-btn"
        />

      </div>
    </div>
  );
};

export default MainMenu;
